import type { FC } from "react";

import classNames from "classnames";
import styled from "styled-components";

import type { ITableCellProps } from "../interfaces/ITableCellProps";

const RightAlignCell = styled.div`
    text-align: right;
`;

/**
 * @deprecated Use TextCell from @similarweb/pro-logic-components instead
 * @see {@link https://gitlab.int.similarweb.io/pro-frontend/pro-logic-components/-/blob/master/src/table/cells/components/core/TextCell/TextCell.tsx}
 */
export const KaKeywordPosition: FC<ITableCellProps> = ({ row, field, className = RightAlignCell }) => {
    const value = row[field];

    return (
        <RightAlignCell className={classNames("cell-innerText", className)}>{value == -1 ? "-" : value}</RightAlignCell>
    );
};

KaKeywordPosition.displayName = "KaKeywordPosition";
